import type { IconSvgObject } from './types';

const AlphaCircleIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 8C15 11 13.8 16 10.8158 16C8.98453 16 7.5 14.2091 7.5 12C7.5 9.79086 8.98453 8 10.8158 8C15 8 13 16 15.5 16C16.0323 16 16.5 15.5556 16.5 15.1111", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default AlphaCircleIcon;
